// extracted by mini-css-extract-plugin
export default {"container":"Product_container__QgqmO"};